export default {
  inProgress: {
    id: 'merchant_options_markets_activity_reach_in_progress_text',
    defaultMessage:
      'Today, you only reach { amount, number, percent } of the total market.',
  },
  complete: {
    id: 'merchant_options_markets_activity_reach_complete_text',
    defaultMessage:
      'Congratulation, you are reaching { amount, number, percent } of BackMarket markets.',
  },
}
